import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService";

const targets = [
  {
    id: 1,
    title: "Month 1 Targets",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+14+Setting+30+day+targets.mp4",
  },
  {
    id: 2,
    title: "Month 2 Targets",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+14+Setting+30+day+targets.mp4",
  },
  {
    id: 3,
    title: "Month 3 Targets",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+14+Setting+30+day+targets.mp4",
  },
];

const Next30Modal = ({ isOpen, onClose }) => {
  const [inputs, setInputs] = useState({});
  
  const [activeIndex, setActiveIndex] = useState(0)

  const textAreaRefs = useRef([])

  useEffect(() => {
    if (isOpen && targets.length > 0) {
      const textArea = textAreaRefs.current[activeIndex];
      if (textArea) {
        textArea.focus();
        const length = textArea.value.length;
        textArea.setSelectionRange(length, length);
      }
    }
  }, [isOpen, activeIndex]);
  


  const handleInputChange = (index, value) => {
    setInputs({
      ...inputs,
      [index]: value,
    });
  };

  const sendNext30 = async () => {
    const completed_inputs = Object.values(inputs).filter(
      (input) => input.trim().length > 0
    );
    const next30_progress =
      (Number(completed_inputs.length) / Number(targets.length)) * 100;

    const payload = {
      first_month_statement: inputs[0],
      second_month_statement: inputs[1],
      third_month_statement: inputs[2],
      progress: next30_progress,
    };

    try {
      const res = await apiServiceHandler("POST", "api/next30", payload);
      if (res.status) {
        toastr.success(res.message)
        onClose()
        setInputs({})
      }
    } catch (error) {
        console.log("Failed to save next 30" + error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/next30");
        if (res.status && res.data) {
          setInputs({
            0: res.data.first_month_statement[0] || "",
            1: res.data.second_month_statement[0] || "",
            2: res.data.third_month_statement[0] || "",
          });
        }
      } catch (error) {
        console.log("Failed to fetch data");
      }
    };

    fetchData();
  }, [isOpen]);

  const handleFocus = (index) => {
    console.log(index, 'index')
    setActiveIndex(index)
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="next90-modal"
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: "none",
          backgroundColor: "#26262f",
          color: "#d1b794",
        }}
      >
        <Modal.Title style={{ fontWeight: "400" }}>NEXT 30</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#26262f" }}>
        <div
          className="edit-key"
          style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          {targets.map((target, index) => (
            <>
              <h4 style={{ fontWeight: "lighter", color: "#fff" }}>
                {target?.title}
              </h4>
              <textarea
                type="text"
                className="credo-input"
                ref={(el) => (textAreaRefs.current[index] = el)}
                value={inputs[index] || ""} 
                onFocus={() => handleFocus(index)}
                onChange={(e) => handleInputChange(index, e.target.value)}
                style={{
                  marginBottom: "1rem",
                  border: "1px solid #d1b794",
                  width: "100%",
                  minHeight: "100px",
                }}
              />
            </>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          borderTop: "none",
          paddingTop: "1rem",
          backgroundColor: "#26262f",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <button
            type="button"
            className="save-next90-btn"
            onClick={sendNext30}
          >
            <span className="driver-button__label">SAVE</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default Next30Modal;
